export const getStoryById = (mediumPartnerProgram, id) => {
    const list = mediumPartnerProgram.payload.postAmounts;
    return list.find((p) => p.post.id === id);
};
